import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import "./Message.css";
import moment from "moment";

function Message({
  author,
  body,
  host,
  authorId,
  timestamp,
  attributes,
  readInfo,
  isLastSent,
  index
}) {
  const classes = classNames("Message", {
    log: !author
  });

  const isHostMessage = host.id === authorId || host.id === attributes?.authorId;

  const msgStatus = () => {
    if (isHostMessage && isLastSent) {
      const read = readInfo?.msgIndex >= index;
      return (
        <span className="author-message-read-info">
          {read
            ? `Read at ${
                readInfo.timestamp !== null
                  ? moment(readInfo.timestamp).format("hh:mm A ")
                  : ""
              }`
            : "Received"}
        </span>
      );
    }
    return null;
  };

  return isHostMessage ? (
    <div
      className={classes}
      style={{ display: "flex", flexDirection: "column", alignItems: "end" }}
    >
      <div className="author-message-info-container">
        {author && <span className="author">{author}</span>}
        <div>-</div>
        <div className="timestamp">{moment(timestamp).format("hh:mm A ")}</div>
      </div>
      <div className="host-message-body">{body}</div>
      {msgStatus()}
    </div>
  ) : (
    <div className={classes}>
      <div className="patient-message-info-container">
        {author && <span className="author">{author}</span>}
        <div>-</div>
        <div className="timestamp">{moment(timestamp).format("hh:mm A ")}</div>
      </div>
      <div className="patient-message-body">{body}</div>
    </div>
  );
}

Message.propTypes = {
  author: PropTypes.string,
  body: PropTypes.string.isRequired,
  host: PropTypes.object,
  authorId: PropTypes.string,
  timestamp: PropTypes.object,
  attributes: PropTypes.object,
  me: PropTypes.bool,
  readInfo: PropTypes.object,
  isLastReceived: PropTypes.bool,
  isLastSent: PropTypes.bool,
  index: PropTypes.number
};

export default Message;
